import React from 'react';
import { useIntl } from 'react-intl';
import { TooltipType, TsrSvgIcon, TsrTooltip } from 'tacho-ui';

export function FormStatusComponent(props: {
    formPending: boolean;
    formErrorMessageToTranslate?: string;
    formErrorMessageTranslated?: string;
}): JSX.Element {
    const { formatMessage } = useIntl();
    return (
        <>
            {props.formErrorMessageToTranslate && props.formErrorMessageToTranslate !== '' && (
                <TsrTooltip type={TooltipType.Error} content={formatMessage({ id: props.formErrorMessageToTranslate })}>
                    <TsrSvgIcon icon="information" color="error" size="large" pointer />
                </TsrTooltip>
            )}
            {props.formErrorMessageTranslated && props.formErrorMessageTranslated !== '' && (
                <TsrTooltip type={TooltipType.Error} content={props.formErrorMessageTranslated}>
                    <TsrSvgIcon icon="information" color="error" size="large" pointer />
                </TsrTooltip>
            )}
        </>
    );
}
